export default __webpack_public_path__ + "static/media/IMG-20180414-WA0003.27c4f4eb.jpg";